import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Home from './pages/Home';
import VideoDetail from './pages/VideoDetail';
import Navbar from './components/Navbar';
import { AuthProvider } from './pages/AuthContext';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          {/* 导航栏 */}
          <Navbar />

          {/* 页面内容 */}
          <main className="bg-white">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/video/:id" element={<VideoDetail />} />
              <Route path="/" element={<Home />} />
            </Routes>
          </main>

          {/* 底部 */}
          <footer className="bg-gray-100 py-6">
            <div className="container mx-auto px-4 text-center text-gray-600 text-sm">
              <p>© 2025 {process.env.REACT_APP_SITE_NAME || 'DutliDutli'}.& DUTYC STUDIO 保留所有权利。</p>
              <p className="mt-2">本项目为个人实验用途，不涉及真实用户数据，生成内容均为模拟数据，无任何商业目的。本项目仅供学习使用，内容来源于互联网</p>
            </div>
          </footer>
        </div>
      </Router>
    </AuthProvider>
  );
}